<template>
  <FileUpload :forPublicDoc="false" />
</template>

<script>
import FileUpload from '@/components/forms/UploadGPTDocumentForm.vue';

export default {
    components: {
        FileUpload,
    },
};
</script>
